import { Link } from '@inertiajs/react'
import type { OrganizationUpload as Upload } from '@/types'
import StatusBadge from './StatusBadge'

interface UploadListItemProps {
    upload: Upload
}

export default function UploadListItem({upload}: UploadListItemProps) {
    return (
        <li key={upload.id}>
            <Link
                href={`/admin/organization_uploads/${upload.id}`}
                className="block px-4 py-6 hover:bg-gray-50 transition-colors"
            >
                <div className="flex items-center justify-between">
                    <div className="flex items-center space-x-4 flex-1 min-w-0">
                        <div className="flex-1 min-w-0">
                            <div className="flex items-center space-x-3">
                                <p className="text-sm font-medium text-gray-900 truncate">
                                    {upload.filename}
                                </p>
                                <StatusBadge
                                    status={upload.status}
                                    hasErrors={upload.has_errors}
                                />
                            </div>

                            <div className="mt-2 flex items-center space-x-4 text-sm text-gray-500">
                                <span>Mode: {upload.import_mode}</span>
                                <span>•</span>
                                <span>{(upload.filesize / 1024).toFixed(1)} KB</span>
                                <span>•</span>
                                <span>{upload.created_at}</span>
                                {upload.organization && (
                                    <>
                                        <span>•</span>
                                        <span>Org: {upload.organization.name}</span>
                                    </>
                                )}
                            </div>


                            {upload.processing_duration && (
                                <p className="mt-2 text-sm text-gray-500">
                                    Processing time: {upload.processing_duration}
                                </p>
                            )}
                        </div>
                    </div>
                </div>
            </Link>
        </li>
    )
}